export default "__VITE_ASSET__CBZeuETZ__"